import { ReactNode, useEffect } from "react";
import { Styles } from "./styled";
import { Spin } from "antd";
import { isMobile, isTablet } from "react-device-detect";

export type TrackingTimeShellVariant = "worker" | "manager";

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  variant?: TrackingTimeShellVariant;
  compactShell?: boolean;
}

const MOBILE_TRACKING_BODY_BG = "#1c1c1c";

const StyleMain = (props: IProps) => {
  const isMobileOrTablet = isMobile || isTablet;
  const shellClass = isMobileOrTablet ? "mobile" : "desktop";

  useEffect(() => {
    if (!isMobileOrTablet) return;
    const prevBackground = document.body.style.background;
    document.body.style.background = MOBILE_TRACKING_BODY_BG;
    return () => {
      document.body.style.background = prevBackground;
    };
  }, [isMobileOrTablet]);

  return (
    <Spin spinning={!!props.isLoading}>
      <Styles className={shellClass} $compactShell={!!props.compactShell}>
        {props.children}
      </Styles>
    </Spin>
  );
};

export default StyleMain;
